const GameState = {
	uninitialized: -1,
	playing: 0,
	done: 1,
	results: 2,
};

document.setDefaultFontSize = function() {
	const container = document.getElementById('game-container');
	const containerWidth = container.clientWidth;
	let fontSize = Math.round(20 * containerWidth / 1055);
	document.documentElement.style.setProperty('--default-font-size', `${fontSize}px`);
}

document.setGameContainerSize = function() {
	const width = window.innerWidth;
	const height = window.innerHeight;
	const container = document.getElementById('game-ratio-container');

	if (height < (width * 2.8 / 4)) {
		container.style.width = `${Math.floor(height * 4 / 2.8)}px`;
	} else {
		container.style.width = `${width}px`;
	}
}

document.computeSizes = function() {
	document.setGameContainerSize();
	document.setDefaultFontSize();
}

document.Game = {
	state: GameState.uninitialized,
	timeBetweenQuestion: 5000, // 5 sec
	timerStarted: false,
	currentQuestionIndex: 0,
	questions: [
		{
			text: "L’articulation la plus touchée par l’arthrose bien qu’elle reste silencieuse.",
			area: { x: 14.8, y: 37.5 }, // In %
			answer: `L’arthrose de la colonne vertébrale a une incidence de <strong>70 à 75%</strong>, mais reste souvent silencieuse. <sup>1,2</sup>`,
			references: `1. Inserm (2012). Arthrose. [en ligne] https://www.inserm.fr/dossier/arthrose/ - consulté le 08.06.2022<br />
2. Lagorce, T., Buxeraud, J., & Guillot, X. (2016). Comprendre l’arthrose. Actualités Pharmaceutiques, 55(555), 18-22.`
		}, {
			text: "La partie du corps où les déformations liées à l’arthrose sont les plus visibles.",
			area: { x: 35.4, y: 12.3 }, // In %
			answer: `L'arthrose de la main et des doigts a une incidence de 60 % et se caractérise par des déformations visibles et irréversibles. <sup>1</sup>`,
			references: `1. Inserm (2012). Arthrose. [en ligne] https://www.inserm.fr/dossier/arthrose/ - consulté le 08.06.2022`,
		}, {
			text: "La localisation de l’arthrose nommée « coxarthrose ».",
			area: { x: 16.4, y: 53.4 },
			answer: `Ce terme vient du latin coxa qui signifie « cuisse ». La coxarthrose est donc l’arthrose de la hanche, qui génère une douleur en haut de la cuisse. <sup>2,3</sup>`,
			references: `2. Lagorce, T., Buxeraud, J., & Guillot, X. (2016). Comprendre l’arthrose. Actualités Pharmaceutiques, 55(555), 18-22.<br />
3. Dictionnaire de l’Académie Française. Coxarthrose. [en ligne] https://www.dictionnaire-academie.fr/article/A9C4741 - consulté le 08.06.2022`
		}, {
			text: "La localisation de l’arthrose nommée « gonarthrose ».",
			area: { x: 33.5, y: 55.8 },
			answer: `Ce terme vient du grec gónu qui signifie « genou ». La gonarthrose est donc bien l’arthrose du genou. <sup>2,4</sup>`,
			references: `2. Lagorce, T., Buxeraud, J., & Guillot, X. (2016). Comprendre l’arthrose. Actualités Pharmaceutiques, 55(555), 18-22.<br />
4. Académie nationale de pharmacie (2016). Gonarthrose. [en ligne] https://dictionnaire.acadpharm.org/w/Gonarthrose - consulté le 08.06.2022`
		}
	],
	render() {
		// Hide all game state
		const gameStates = document.getElementsByClassName('game-state');
		for (let i = 0; i < gameStates.length; i++) {
			if (!gameStates[i].classList.contains('hidden')) {
				gameStates[i].classList.add('hidden');
			}
		}
		// Call method to prepare everything then display the current state
		switch (this.state) {
			case GameState.playing:
				this._renderAnswerArea();
				this._renderCurrentQuestion();
				document.getElementById('state-playing').classList.remove('hidden')
				break;
			case GameState.done:
				document.getElementById('state-done').classList.remove('hidden')
				break;
			case GameState.results:
				document.getElementById('state-results').classList.remove('hidden')
				break;
		}
	},
	_renderCurrentQuestion() {
		// Fill in question zone with the question until now
		const container = document.getElementById('game-questions-list');
		let innerHtml = ``;
		this.questions.slice(0, this.currentQuestionIndex + 1).forEach(q => {
			innerHtml += `<p>${q.text}</p>`;
		});
		container.innerHTML = innerHtml;
	},
	answer(selectedAnswerIndex) {
		if (this.timerStarted) return; // Don't answer when you already found and are waiting for the next question

		// Clean up old (Maybe could be reused)
		document.getElementById('error-message') && document.getElementById('error-message').remove();
		document.getElementById('success-message') && document.getElementById('success-message').remove();

		if (this.currentQuestionIndex !== selectedAnswerIndex) {
			const errorDiv = document.createElement('div')
			errorDiv.innerHTML = "Oups ! Ce n'est pas ici.";
			errorDiv.setAttribute("id", "error-message");
			errorDiv.style.left = this.questions[selectedAnswerIndex].area.x + "%";
			errorDiv.style.top = this.questions[selectedAnswerIndex].area.y + "%";
			document.getElementById('game-answers').appendChild(errorDiv);
			return;
		}

		const successDiv = document.createElement('div')
		successDiv.innerHTML = `<strong>Exact!</strong><br/>${this.questions[this.currentQuestionIndex].answer}`;
		successDiv.setAttribute("id", "success-message");
		if (this.questions[selectedAnswerIndex].area.x > 30) {
			successDiv.classList.add('right');
		}
		successDiv.style.left = this.questions[selectedAnswerIndex].area.x + "%";
		successDiv.style.top = this.questions[selectedAnswerIndex].area.y + "%";
		document.getElementById('game-answers').appendChild(successDiv);

		document.getElementById('game-references').innerHTML = `Références:<br/>${this.questions[selectedAnswerIndex].references}`;

		this.timerStarted = true;
		setTimeout(() => {
			this.next();
			this.timerStarted = false;
			document.getElementById('success-message') && document.getElementById('success-message').remove();
			document.getElementById('game-references').innerHTML = '';

		}, this.timeBetweenQuestion);
	},
	_renderAnswerArea() {
		let innerHtml = ``;
		this.questions.forEach((q, i) => {
			innerHtml += `<div class="answer-area" 
				style="left: ${q.area.x}%; top: ${q.area.y}%"
				onclick="document.Game.answer(${i})"
			></div>`;
		});

		document.getElementById('game-answers').innerHTML = innerHtml;
	},
	restart() {
		this.currentQuestionIndex = 0;
		this.state = GameState.playing;
		this.render();
	},
	next() {
		this.currentQuestionIndex += 1;
		if (this.currentQuestionIndex === this.questions.length) {
			this.state = GameState.done;
		}
		this.render();
	},
	seeResults() {
		this.state = GameState.results;
		this.render();
	}
}

document.computeSizes();
document.Game.restart();
addEventListener('resize', document.computeSizes);
